import { render, staticRenderFns } from "./CardOriginDestinyReturn.vue?vue&type=template&id=4d44ec7a&"
import script from "./CardOriginDestinyReturn.vue?vue&type=script&lang=js&"
export * from "./CardOriginDestinyReturn.vue?vue&type=script&lang=js&"
import style0 from "./CardOriginDestinyReturn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports